import { AxiosResponse } from "axios";

export const successInterceptor = (response: AxiosResponse<any, any>) => {
  if (response.data && !response.data.status) {
    throw new Error(response.data.message || "Ocorreu um erro no servidor");
  }
  return {
    status: response.status,
    ...response.data,
  };
};
